import React from 'react'

import { TilesModal } from '@components/modals/TilesModal'
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { routing } from '@utils/routing'

import giftCardImage from './assets/giftCard.png'
import giveawayLinksImage from './assets/giveawayLinks.png'
import membershipsPromoImage from './assets/membershipsPromo.png'
import shopPromoImage from './assets/shopPromo.png'

export const CreatePromotionModal = () => {
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const { hasPermission } = useDashboardPermissions()

  const shopPromoEnabled = hasPermission('promotions.shopPromoCodes')
  const membershipsPromoEnabled =
    dashboardFeatureFlags.memberships.enabled && hasPermission('promotions.membershipsPromoCodes')
  const giveawayLinksEnabled = hasPermission('promotions.giveawayLinks')
  const giftCardsEnabled =
    hasPermission('promotions.giftCards') && dashboardFeatureFlags.giftCards.enabled

  const enabledItemsCount = [
    shopPromoEnabled,
    membershipsPromoEnabled,
    giveawayLinksEnabled,
    giftCardsEnabled,
  ].filter(Boolean).length

  if (enabledItemsCount === 0) {
    return null
  }

  return (
    <TilesModal itemsCount={enabledItemsCount}>
      <TilesModal.Items>
        {shopPromoEnabled && (
          <TilesModal.Item
            image={shopPromoImage}
            imageAlt="Shop promo"
            heading="Shop promo"
            subheading="Offer discounts on products in your shop"
            to={routing.promotions.promotionCodes.create.self}
          />
        )}
        {membershipsPromoEnabled && (
          <TilesModal.Item
            image={membershipsPromoImage}
            imageAlt="Memberships promo"
            heading="Memberships promo"
            subheading="Offer discounts on memberships pricing"
            to={routing.promotions.promotionCodes.membershipsPromotionCreate.self}
          />
        )}
        {giveawayLinksEnabled && (
          <TilesModal.Item
            image={giveawayLinksImage}
            imageAlt="Giveaway links"
            heading="Giveaway links"
            subheading="Give products away for free through unique links"
            to={routing.promotions.giveawayPackages.create.self}
          />
        )}
        {giftCardsEnabled && (
          <TilesModal.Item
            image={giftCardImage}
            imageAlt="Gift card"
            heading="Gift card"
            subheading="Digital gift cards that can be used on any order."
            to={routing.promotions.giftCards.create.self}
          />
        )}
      </TilesModal.Items>
    </TilesModal>
  )
}
